// extracted by mini-css-extract-plugin
module.exports = {"collaborator":"styles_collaborator__Uin5E","info":"styles_info__3ZF4R","email":"styles_email__1tfrk"};